import { HttpClient } from '@angular/common/http';
import { Directive } from '@angular/core';
import { LogService, UseCase } from '@prekog/common-ui';

@Directive()
export abstract class CalculateStatisticTotalsUseCase<ROW extends object, TOTALS extends object> extends UseCase<
    { list: ROW[]; selectedIndex: number },
    TOTALS
> {
    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: { list: ROW[]; selectedIndex: number } | void): TOTALS | void {
        if (!request) {
            return;
        }
        return this.extractRowTotals(request.list[request.selectedIndex]);
    }

    protected abstract extractRowTotals(row: ROW): TOTALS;
}
